import React from "react";
import { IonButton, IonSpinner, IonText } from "@ionic/react";

import "./ButtonLoading.css";

export interface ButtonLoadingProps {
  disabled?: boolean;
  loading: boolean;
  text?: string;
  textLoading?: string;
  style?: Object;
  onClick?: (event: any) => any;
}

export const ButtonLoading: React.FC<ButtonLoadingProps> = ({
  loading,
  text,
  textLoading,
  onClick,
  disabled = false,
  style = {},
}) => {
  return (
    <IonButton
      disabled={loading || disabled}
      onClick={onClick}
      type="submit"
      className="btn-loading"
      style={style}
    >
      {loading ? (
        <IonSpinner slot="start" style={{ marginRight: "1rem" }} />
      ) : null}
      <IonText>{loading ? textLoading || text + "..." : text}</IonText>
    </IonButton>
  );
};
